<div class="chart-setup-modal">
  <h2 mat-dialog-title>
    {{ data.visualization ? 'Edit' : 'Add' }} Chart
    <button mat-icon-button matTooltip="Close" (click)="close()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <app-reporting-builder-visualizations-chart-setup
      [title]="data.title"
      [fields]="data.fields"
      [visualization]="data.visualization"
      [isTimeSeries]="data.isTimeSeries"
      [allowRelatedObjectFields]="data.allowRelatedObjectFields"
      (close)="onCloseCreateVisualization($event)"
    ></app-reporting-builder-visualizations-chart-setup>
  </mat-dialog-content>
</div>
